import { memo, useCallback } from "react";
import Image from "next/image";
import Logo from "@/public/icons/logo.svg";
import CodeInput from "../code-input";
import { Button } from "@/ui/button/button";
import styles from "../login-modal.module.css";

export const CodeInputScreen = memo(
  ({
    phoneNumber,
    timeLeft,
    onCodeChange,
    onCodeSubmit,
    onResendCode,
    error,
  }: {
    phoneNumber: string;
    timeLeft: number | null;
    onCodeChange: (value: string) => void;
    onCodeSubmit: () => void;
    onResendCode: () => void;
    error: boolean;
  }) => {
    const handleCodeChange = useCallback(
      (value: string) => {
        if (/^\d*$/.test(value)) {
          onCodeChange(value);
        }
      },
      [onCodeChange],
    );

    return (
      <>
        <Image priority src={Logo} alt="logo" width={200} height={80} />
        <div className={styles.phoneTitle}>Подтвердите свой номер</div>
        <div className={styles.description}>
          Мы позвоним вам на указанный номер телефона и продиктуем код
        </div>
        <div className={styles.description}>Ожидается звонок на: {phoneNumber}</div>

        <div className={styles.codeInput}>
          <CodeInput onChange={handleCodeChange} error={error} />
        </div>
        <div className={styles.getCode}>Не поступил звонок?</div>

        <div
          className={styles.getCodeButton}
          style={timeLeft ? { color: "#727272" } : { color: "#AF2F18" }}
          onClick={!timeLeft ? onResendCode : undefined}
        >
          Позвонить снова{" "}
          {timeLeft ? `через ${Math.ceil(timeLeft / 1000)}сек` : ""}
        </div>
        <div className={styles.controls}>
          <Button
            type="primary"
            className={styles.loginButton}
            onClick={onCodeSubmit}
          >
            Далее
          </Button>
        </div>
      </>
    );
  },
);
